function upperCase(str) {
  return str.toUpperCase();
}

export function TitleCase(str) {
  return str;
}

export function TitleCase2(str) {
  var firstLetterRx = /(^|\s)[a-z]/g;
  return str.toLowerCase().replace(firstLetterRx, upperCase);
}

export function CheckRule(show, value_x, elementr) {
  switch (elementr.c_operation) {
    case "eq":
      if (value_x === elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "neq":
      if (value_x !== elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "gt":
      if (value_x > elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "lt":
      if (value_x < elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "lte":
      if (value_x <= elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "gte":
      if (value_x >= elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "contains":
      if (value_x.indexOf(elementr.c_value) !== -1) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "doesnotcontain":
      if (value_x.indexOf(elementr.c_value) === -1) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;

    case "startswith":
      if (value_x.substr(0, 1) === elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    case "endswith":
      if (value_x.substr(value_x.length - 1, 1) === elementr.c_value) {
        if (elementr.c_logic === "or") {
          show += " || true";
        } else {
          if (elementr.c_logic === "and") {
            show += " && true";
          } else {
            show = "true";
          }
        }
      } else {
        if (elementr.c_logic === "or") {
          show += " || false";
        } else {
          if (elementr.c_logic === "and") {
            show += " && false";
          } else {
            show = "false";
          }
        }
      }
      break;
    default:
      break;
  }

  return show;
}



// WEBPACK FOOTER //
// ./src/common/index.js